


















































































































import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import _ from 'lodash';
import MyList from '@/mixins/list';

import Add from './vip_setting_add.vue';
import Edit from './vip_setting_edit.vue';

@Component({
  components: {
    Add,
    Edit,
  },
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  formData: { [t: string]: any } = {};

  editId = 0;

  oldData: any = {};

  rechargeRules: any[] = [];

  status = 0;

  hideAddModal1() {
    this.addModalVisible = false;
    this.loadData1();
  }

  showEditModal1(sn: number, oldData: any) {
    this.editId = sn;
    this.oldData = oldData;
    this.editModalVisible = true;
  }

  hideEditModal1() {
    this.editModalVisible = false;
    this.loadData1();
  }

  handleSubmit() {
    this.form.validateFields((err: any, fieldsValue: any) => {
      if (!err) {
        this.$confirm({
          title: '确认信息',
          content: '确定要提交吗？',
          onOk: async () => {
            this.confirmLoading = true;

            const res = await this.$store.dispatch('stadium/savevipsetting', {
              stadium_id: this.stadiumId,
              recharge_rules: JSON.stringify(
                _.sortBy(this.rechargeRules, (o: any) => Number(o.valid_sn)),
              ),
              ...fieldsValue,
            });
            if (res && res.Message && res.Message === 'success') {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  async on(sn: number) {
    this.$confirm({
      title: '确认信息',
      content: '你确定要上架销售？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/vipSettingOn', {
          stadium_id: this.stadiumId,
          valid_sn: sn,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);

          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  async off(sn: number) {
    this.$confirm({
      title: '确认信息',
      content: '你确定要停止销售吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/vipSettingOff', {
          stadium_id: this.stadiumId,
          valid_sn: sn,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  async del(sn: number) {
    this.$confirm({
      title: '确认信息',
      content: '你确定要删除吗？',
      onOk: async () => {
        const res = await this.$store.dispatch('stadium/vipSettingDelete', {
          stadium_id: this.stadiumId,
          valid_sn: sn,
        });
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      },
    });
  }

  changeStatus(e: any) {
    const status: number = e.target.value;
    let str = '';
    let oldstatus: number = this.formData.status;
    if (status === 1) {
      str = '开启';
      oldstatus = 0;
    } else {
      str = '关闭';
      oldstatus = 1;
    }
    this.$confirm({
      title: '确认信息',
      content: `确定要${str}会员卡吗？`,
      onOk: async () => {
        const res = await this.$store.dispatch(
          'stadium/changeVipSettingStatus',
          {
            stadium_id: this.stadiumId,
            status,
          },
        );
        if (res && res.Message && res.Message === 'success') {
          this.status = status;
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.Message);
        }
      },
      onCancel: async () => {
        this.status = oldstatus;
      },
    });
  }

  addRule() {
    this.rechargeRules.push({
      face_value: 0,
      sale_price: 0,
      valid_month: '0',
      valid_sn: this.rechargeRules.length + 1,
    });
  }

  deleteRule(idx: number) {
    this.$confirm({
      title: '确认信息',
      content: '确定要删除会员卡类型吗？',
      onOk: () => {
        this.rechargeRules.splice(idx, 1);

        this.$emit('change', this.rechargeRules);
      },
    });
  }

  async loadData1() {
    this.spinLoading = true;
    const res = await this.$store.dispatch('stadium/getvipsetting', {
      stadium_id: this.stadiumId,
    });
    if (res && res.Data && res.Data !== '{}') {
      this.formData = res.Data;
      this.status = res.Data.status;
      if (res.Data.recharge_rules) {
        const rules1 = JSON.parse(res.Data.recharge_rules);

        this.rechargeRules = _.sortBy(rules1, (o: any) => Number(o.valid_sn));
      }
    }
    this.spinLoading = false;
  }

  async mounted() {
    this.loadData1();
  }
}
